// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export class WebSocketClient {
    constructor(uri, protocolName) {
        this._socket = new WebSocket(uri, protocolName);
        this._socket.binaryType = "arraybuffer";
    }
    onopen(fn) {
        this._socket.onopen = fn;
    }
    onclose(fn) {
        this._socket.onclose = (ev) => fn(ev.code, ev.reason);
    }
    onerror(fn) {
        this._socket.onerror = (ev) => fn(ev);
    }
    onmessage(fn) {
        this._socket.onmessage = (event) => fn(event.data);
    }
    close(code, reason) {
        this._socket.close(code, reason);
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    send(data, _) {
        return new Promise((resolve, reject) => {
            try {
                this._socket.send(data);
                resolve();
            }
            catch (err) {
                reject(err);
            }
        });
    }
    isOpen() {
        return this._socket.readyState === WebSocket.OPEN;
    }
}
export class WebSocketClientFactory {
    create(uri, protocolName) {
        return new WebSocketClient(uri, protocolName);
    }
}
//# sourceMappingURL=websocketClient-browser.mjs.map